import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["value", "extension"];
import { useContext } from 'react';
import formatPhoneNumber from 'I18n/utils/formatPhoneNumber';
// @ts-expect-error untyped JS module
import formatPhoneNumberWithExtension from 'I18n/utils/formatPhoneNumberWithExtension';
import { I18nHMRContext } from '../internal/i18n-internal';
import { jsx as _jsx } from "react/jsx-runtime";
function FormattedPhoneNumber(_ref) {
  let {
      value,
      extension
    } = _ref,
    passThroughProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  useContext(I18nHMRContext);
  return /*#__PURE__*/_jsx("span", Object.assign({}, passThroughProps, {
    children: extension ? formatPhoneNumberWithExtension(value, extension) :
    // @ts-expect-error formatPhoneNumber accepts 1 arg at runtime
    formatPhoneNumber(value)
  }));
}
FormattedPhoneNumber.displayName = 'FormattedPhoneNumber';
export default FormattedPhoneNumber;